module.exports = __webpack_public_path__ + "static/media/favicon.3a9b6da5.ico";